import React, { useEffect, useState, useMemo } from 'react';
import { getdata, updatedata } from '../../util/global';
import TableLedger from './TableLedger';
import LedgerForm from './LedgerForm';

const SEEDLEDGERS = [
  { ledgername: "Audit & Professional Fees", tallygroup: "Indirect Expenses" },
  { ledgername: "Bank Charges", tallygroup: "Indirect Expenses" },
  { ledgername: "Business Entertainment", tallygroup: "Indirect Expenses" },
  { ledgername: "Courier & Delivery", tallygroup: "Indirect Expenses" },
  { ledgername: "Insurance", tallygroup: "Indirect Expenses" },
  { ledgername: "Miscellaneous Expenses", tallygroup: "Indirect Expenses" },
  { ledgername: "Parking", tallygroup: "Indirect Expenses" },
  { ledgername: "Repairs & Maintenance", tallygroup: "Indirect Expenses" },
  { ledgername: "Salaries & Wages", tallygroup: "Indirect Expenses" },
  { ledgername: "Telephone & Internet", tallygroup: "Indirect Expenses" },
  { ledgername: "Travel & Conveyance - Local", tallygroup: "Indirect Expenses" },
  { ledgername: "Utilities - District Cooling", tallygroup: "Indirect Expenses" },
  { ledgername: "Utilities - Electricity & Water", tallygroup: "Indirect Expenses" },
  { ledgername: "Vehicle - Fuel", tallygroup: "Indirect Expenses" },
  { ledgername: "Vehicle - Salik & Tolls", tallygroup: "Indirect Expenses" },
  { ledgername: "Rent", tallygroup: "Indirect Expenses" },
  { ledgername: "Consultancy Income", tallygroup: "Sales Accounts" },
  { ledgername: "Motor Vehicles", tallygroup: "Fixed Assets" },
  { ledgername: "JAFZA Portal Deposit", tallygroup: "Deposits (Asset)" },
  { ledgername: "Prepaid Rent", tallygroup: "Current Assets" },
  { ledgername: "Prepaid Insurance", tallygroup: "Current Assets" },
  { ledgername: "Recoverable from Landlord", tallygroup: "Loans & Advances (Asset)" },
  { ledgername: "Shareholder Current A/c", tallygroup: "Current Liabilities" },
  { ledgername: "Input VAT 5%", tallygroup: "Duties & Taxes" },
  { ledgername: "Bank - AED Account", tallygroup: "Bank Accounts" },
  { ledgername: "Bank - USD Account", tallygroup: "Bank Accounts" },
  { ledgername: "Suspense A/c", tallygroup: "Suspense A/c" },
];

const EMPTYLEDGER = { _id: null, ledgername: "", tallygroup: "Indirect Expenses", active: true, datatype: "prudentialledger" };

const PrudentialLedgers = () => {
  const [ledgerdata, setledgerdata] = useState<any[]>([]);
  const [mode, setmode] = useState<string | null>(null);
  const [formdata, setformdata] = useState<any>({ ...EMPTYLEDGER });

  const sortedledgerdata = useMemo(() => {
    const sorted = ledgerdata.slice();
    sorted.sort((a, b) => a.ledgername.localeCompare(b.ledgername));
    return sorted;
  }, [ledgerdata]);

  const seedledgers = async () => {
    const dataset = [];
    for (let i = 0; i < SEEDLEDGERS.length; i++) {
      dataset.push({
        ledgername: SEEDLEDGERS[i].ledgername,
        tallygroup: SEEDLEDGERS[i].tallygroup,
        active: true,
        datatype: "prudentialledger",
      });
    }
    await updatedata({ dataset: dataset });
  };

  const fetchdata = async () => {
    let data = await getdata({ filter: { datatype: "prudentialledger" } });
    if (!Array.isArray(data)) {
      return;
    }
    if (data.length == 0) {
      await seedledgers();
      data = await getdata({ filter: { datatype: "prudentialledger" } });
    }
    setledgerdata(data);
  };

  const openadd = () => {
    setformdata({ ...EMPTYLEDGER });
    setmode("editledger");
  };

  const openedit = (ledger: any) => {
    setformdata({
      _id: ledger._id,
      ledgername: ledger.ledgername,
      tallygroup: ledger.tallygroup,
      active: ledger.active,
      datatype: "prudentialledger",
    });
    setmode("editledger");
  };

  const saveledger = async () => {
    const ledgername = formdata.ledgername.trim();
    if (!ledgername) {
      alert("Ledger name is required");
      return;
    }
    for (let i = 0; i < ledgerdata.length; i++) {
      const existing = ledgerdata[i];
      if (existing._id != formdata._id && existing.ledgername.toLowerCase() == ledgername.toLowerCase()) {
        alert("Ledger " + existing.ledgername + " already exists");
        return;
      }
    }
    await updatedata({ data: { ...formdata, ledgername: ledgername } });
    setmode(null);
    await fetchdata();
  };

  const toggleactive = async (ledger: any) => {
    await updatedata({ data: { _id: ledger._id, datatype: "prudentialledger", active: !ledger.active } });
    await fetchdata();
  };

  useEffect(() => { fetchdata(); }, []);

  return (
    <>
      <div className="page-header">
        <h2>Ledgers</h2>
        <button className="btn-primary" onClick={openadd}>Add ledger</button>
      </div>

      <TableLedger ledgerdata={sortedledgerdata} openedit={openedit} toggleactive={toggleactive} />

      <LedgerForm
        mode={mode}
        setmode={setmode}
        formdata={formdata}
        setformdata={setformdata}
        saveledger={saveledger}
      />
    </>
  );
};

export default PrudentialLedgers;
